var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalIconRoom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 25,
    stroke: "#BBBBBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.0971C18 16.594 18.4942 16 19.3467 16H36.6533C37.5058 16 38 16.594 38 17.0971V39.9029C38 40.406 37.5058 41 36.6533 41H19.3467C18.4942 41 18 40.406 18 39.9029V17.0971Z",
    fill: "white",
    stroke: "#BBBBBD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.0223C24 14.4966 24.6207 13.8482 25.5546 14.0283L37.0236 16.2394C37.6744 16.3649 38 16.8366 38 17.2334V28.3105V28.6895V39.7666C38 40.1634 37.6744 40.6351 37.0236 40.7606L25.5546 42.9717C24.6207 43.1518 24 42.5034 24 41.9777V28.6895V28.3105V15.0223Z",
    fill: "white",
    stroke: "#BBBBBD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28.5C27.5 28.8293 27.4101 29.1048 27.2911 29.2833C27.1697 29.4654 27.057 29.5 27 29.5C26.943 29.5 26.8303 29.4654 26.7089 29.2833C26.5899 29.1048 26.5 28.8293 26.5 28.5C26.5 28.1707 26.5899 27.8952 26.7089 27.7167C26.8303 27.5346 26.943 27.5 27 27.5C27.057 27.5 27.1697 27.5346 27.2911 27.7167C27.4101 27.8952 27.5 28.1707 27.5 28.5Z",
    fill: "white",
    stroke: "#BBBBBD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconRoom);
export default __webpack_public_path__ + "static/media/ModalIconRoom.14078d237d8d402c5e5dadc273bba0f6.svg";
export { ForwardRef as ReactComponent };